// extracted by mini-css-extract-plugin
export default {"flex":"ayPnGthO3VD0fKWcTY1L"};